export default __webpack_public_path__ + "static/media/copy.6f9a1526.svg";